import { HStack, Text } from "@chakra-ui/react";
import {
  chakraComponents,
  PlaceholderProps,
  ValueContainerProps,
} from "chakra-react-select";
import React from "react";
import { useTranslation } from "react-i18next";
import { SelectComponentsConfig } from "react-select/dist/declarations/src/components";
import { SelectButtonProps } from "shared/components/input/select/SelectButton";
import { selectComponentsConfig } from "shared/components/input/select/SelectComponents";
import { SelectOptionData } from "shared/components/input/select/SelectTypes";

const ValueContainer: React.FC<ValueContainerProps<SelectOptionData>> = ({
  children,
  ...props
}) => {
  const selectProps = props.selectProps as unknown as
    | SelectButtonProps
    | undefined;
  return (
    <HStack className="react-select__value-container__wrapper">
      {selectProps?.isFilterButton && (
        <Text className="react-select__value-container__title">
          {props.selectProps.placeholder}
        </Text>
      )}
      <chakraComponents.ValueContainer {...props}>
        {children}
      </chakraComponents.ValueContainer>
    </HStack>
  );
};

const Placeholder: React.FC<PlaceholderProps<SelectOptionData>> = ({
  children,
  ...props
}) => {
  const { t } = useTranslation(["common"]);
  const selectProps = props.selectProps as unknown as
    | SelectButtonProps
    | undefined;
  return (
    <chakraComponents.Placeholder {...props}>
      {selectProps?.isFilterButton ? t("common:all") : children}
    </chakraComponents.Placeholder>
  );
};

export const selectButtonComponentsConfig: SelectComponentsConfig<
  SelectOptionData,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
> = {
  ...selectComponentsConfig,
  ValueContainer,
  Placeholder,
};
